<div class="row px-3 navbar-container">
  <div class=" navbar-items">
    <div class="nav-item">Mapa</div>
    <div class="nav-item">Dashboard</div>
    <div class="nav-item">Gestão</div>
    <div class="nav-item">Cadastro</div>
    <div class="nav-item">Catálogo</div>
    <div class="nav-item">Serviços</div>
  </div>
</div>
